define("static/js/base-conf",function(n,e){var i=1;e.version=i});